import React, { Component } from 'react'
// import PropTypes from 'prop-types'

export default class InfoSectionDescription1 extends Component {
  // static propTypes = {
  //   prop: PropTypes
  // }
  render() {
    return (
      <span>
        My name is Dallas Boyer. I am a Freelance Front-End Web Developer who designs and develops websites, web apps, and phone apps. I am skilled in web technologies such as: Javascript, React, and React Native. I possess a Bachelor's of Science in Electronic Engineering Technology from DeVry University and post baccalaureate programming certification from Udacity React Nanodegree Program.  I have worked in a variety of industries and technologies including biomedical electronics, <a href="http://www.modularmining.com/product/dispatch-underground/" alt="Mining dispatch system for underground mine equipment">mining dispatch systems</a>, fiber optics, RFID, audio/visual, and Nevada gaming technologies. I have dabbled in web design since 2009. In early 2014 my intrinsic entrepreneurial instincts took root, and I began web designing full-time.  I am dedicated, straight-forward, and passionate.  That is what you can expect when collaborating with me.  Integrity is my priority and I am confident that when given the opportunity to work with you I will achieve whatever it is you desire.  Please take a look at the projects on my home page to get a sense of what I can do.
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/config/custom-components/InfoSectionDescription1.js